import { createFileRoute, redirect } from "@tanstack/react-router"
import { FinanceDuesPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

const VALID_TABS = ["dashboard", "invoices", "settings"] as const

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/dues/$tabKey"
)({
  beforeLoad: ({ params }) => {
    if (!VALID_TABS.includes(params.tabKey as (typeof VALID_TABS)[number])) {
      throw redirect({
        to: "/finance/dues/$tabKey",
        params: { tabKey: "dashboard" },
      })
    }
  },
  component: () => (
    <AuthorizationGate resource={Resource.INVOICE} action={Action.READ}>
      <FinanceDuesPage />
    </AuthorizationGate>
  ),
})
